import { makeStyles /*, TextField */ } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import ToleranceQualityCheck from '../QualityCheckTypes/ToleranceQualityCheck';
import YesNoQualityCheck from '../QualityCheckTypes/YesNoQualityCheck';
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
import { bool, decimal, QualityOutOfSpec, uomMm, uomKg, UnKnownQualityCheckType, dimensionQualityChecks } from '../../../Config/constants';
import AlertDialog from '../../Shared/Dialogs/AlertDialog';
import { CalculateToleranceFactor } from '../../../Helpers/QualitySampleHelper';

export default function QualityCheckForm(props) {
    const classes = useStyles();
    const { t } = useTranslation();
    const [sequence, setSequence] = useState(0);
    const [fieldsEmptyDialogOpen, setFieldsEmptyDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);
    const [toleranceFactor, setToleranceFactor] = useState(null);
    const [plateLength, setPlateLength] = useState(null);
    const [plateWidth, setPlateWidth] = useState(null);
    const [calculatedWeight, setCalculatedWeight] = useState(null);
    const [measuredWeight, setMeasuredWeight] = useState(null);
    const [lengteUom, setLengteUom] = useState(null);
    const [breedteUom, setBreedteUom] = useState(null);
    const [emptyFieldCodes, setEmptyFieldCodes] = useState([]);

    let history = useHistory();

    useEffect(() => {
        if (props.qualityChecks) {

            checkForUnKnownQualityCheckTypes(props.qualityChecks)
            if (props.qualityChecks.qualitySamples.length !== sequence + 1) {
                setSequence(props.qualityChecks.qualitySamples.length - 1)
            }
            setToleranceFactor(CalculateToleranceFactor(props.qualityChecks.qualitySamples[0].samples.filter(x => x.dataTypeId === decimal && x.toleranceMin !== null)))
        }
    }, [])

    const checkForUnKnownQualityCheckTypes = (qualityChecks) => {
        let samples = qualityChecks.qualitySamples[0].samples
        if (qualityChecks.qualitySamples.length !== 1) {
            samples = qualityChecks.qualitySamples[qualityChecks.qualitySamples.length - 1].samples
        }
        var i;
        for (i = 0; i < samples.length; i++) {
            if (samples[i].dataTypeId !== bool && samples[i].dataTypeId !== decimal) {

                let message = "Unknown quality check (" + samples[i].code + ") type for pallet " + props.palletNumber + ", on line " + props.productionOrder.machineCode
                dataService.saveNotification(UnKnownQualityCheckType, message, props.palletNumber, props.workstation.selectedWorkstation, 0, props.productionOrder.reference, samples[i].id).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            }
        }
    }

    const qualityCheckChanged = (event, code) => {
        let tempQualityChecks = Object.assign({}, props.qualityChecks)
        if (tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code).dataTypeId === decimal) {
            if (event.target.value === "") {
                tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code).sampleValue = "0"
            }
            else {
                tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code).sampleValue = event.target.value
            }
        }
        else if (tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code).dataTypeId === bool) {
            if (event.target.value === 'true') {
                tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code).resultOk = true
            }
            else {
                tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code).resultOk = false
            }
        }

        if (tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code).description.includes("Lengte")) {
            setPlateLength(event.target.value)
        }
        if (tempQualityChecks.qualitySamples[sequence].samples.find(x => x.code === code).description.includes(dimensionQualityChecks.BREEDTE)) {
            setPlateWidth(event.target.value)
        }

        props.setQualityChecks(tempQualityChecks)
    }

    const saveQualityChecks = () => {

        if (checkForEmptyValues()) {
            setDialogTitle(t("Empty fields"))
            setDialogContext(t("Please fill in the required fields"))
            setFieldsEmptyDialogOpen(true)
        }
        else {

            dataService.GetCheckNumberForPallet(props.palletNumber).then(seq => {

                let qualityWeightCheck = props.qualityChecks.qualitySamples[sequence].samples.find(x => x.description.includes(dimensionQualityChecks.GEWICHT))
                if (qualityWeightCheck.uom.includes(uomKg)) {                    
                    qualityWeightCheck.sampleValue = String(parseFloat(qualityWeightCheck.sampleValue) / 1000)
                }

                props.qualityChecks.qualitySamples[sequence].carrierInfo.sampleSequence = seq

                validateForNotification(seq, props.qualityChecks)

                dataService.saveQualitySamples(props.qualityChecks, props.productionOrder.id, props.productionOrder.machineCode).then(
                    setTimeout(() => { history.push('/sampling/' + props.productionOrder.id + '/' + props.palletNumber + "/" + props.progress + "/1") }, 1000)
                ).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
            }).catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })

        }
    }

    const validateForNotification = (seq,qualityChecks) => {
        let qualitySamplesNotOK = []
        var i;
        for (i = 0; i < qualityChecks.qualitySamples[sequence].samples.length; i++) {
            let sample = qualityChecks.qualitySamples[sequence].samples[i]

            if (!sample.resultOk && sample.dataTypeId === bool) {
                qualitySamplesNotOK.push(sample)
            }

            if (sample.dataTypeId === decimal) {
                if (sample.toleranceMax !== null && sample.toleranceMin !== null) {
                    if (parseFloat(sample.sampleValue) - sample.toleranceMax > sample.expectedValue || parseFloat(sample.sampleValue) + sample.toleranceMin < sample.expectedValue) {
                        qualitySamplesNotOK.push(sample)
                    }
                }
            }
        }

        if (qualitySamplesNotOK.length > 0) {
            let message = t("Qualitycheck out of spec for production order ") + props.productionOrder.reference + ", pallet: " + props.palletNumber + t(", on line ") + props.productionOrder.machineCode
            dataService.saveNotification(QualityOutOfSpec, message, props.palletNumber, props.workstation.selectedWorkstation, seq, props.productionOrder.reference, 0).then().catch((error) => { toast.error(error, { position: toast.POSITION.TOP_CENTER }) })
        }
    }

    const checkForEmptyValues = () => {
        var valueChecks = props.qualityChecks.qualitySamples[sequence].samples.filter(x => x.dataTypeId === decimal)

        var notFilled= [];
        for (var i=0; i<valueChecks.length; i++) {
            if (valueChecks[i].sampleValue === null) {
                notFilled.push(valueChecks[i].code)
            }
          }
          setEmptyFieldCodes(notFilled);
        if (valueChecks.some(x => x.sampleValue === null || x.sampleValue === 0)) {
            return true
        }
        else {
            return false

        }
    }

    const calculateWeightPerSquareM = () => {
        if (plateLength > 0 && plateWidth > 0) {
            
            let lengteFactor = 1;
            let breedteFactor = 1;
            if (lengteUom === uomMm) {
                lengteFactor = 0.001
            }
            if (breedteUom === uomMm) {
                breedteFactor = 0.001
            }

            let totalFactor = lengteFactor * breedteFactor

            setCalculatedWeight(measuredWeight * 1000 / (plateLength * plateWidth * totalFactor))
            let tempQualityChecks = Object.assign({}, props.qualityChecks)
            tempQualityChecks.qualitySamples[sequence].samples.filter(x => x.dataTypeId === decimal).find(x => x.description.includes("Gewicht")).sampleValue = String(measuredWeight * 1000 / (plateLength * plateWidth * totalFactor))
            props.setQualityChecks(tempQualityChecks)
        }
    }

    const measuredWeightChanged = (weight) => {
        setMeasuredWeight(weight)
    }

    return (
        <div className={classes.background}>
            <div className={classes.spacer}>
            </div>
            <div className={classes.toleranceTitle}>
                {props.qualityChecks.qualitySamples[sequence].samples.some(x => x.dataTypeId === decimal) && t("Tolerance")}
            </div>
            {props.qualityChecks ? props.qualityChecks.qualitySamples[sequence].samples.sort((a, b) => new Date(b.dataTypeId) - new Date(a.dataTypeId)).map(x => {
                if (x.dataTypeId === decimal) {

                    return (
                        toleranceFactor &&
                        <ToleranceQualityCheck {...props} setLengteUom={setLengteUom} setBreedteUom={setBreedteUom} lengteUom={lengteUom} breedteUom={breedteUom} measuredWeightChanged={measuredWeightChanged} calculateWeightPerSquareM={calculateWeightPerSquareM} measuredWeight={measuredWeight} calculatedWeight={calculatedWeight} setPlateLength={setPlateLength} setPlateWidth={setPlateWidth} plateWidth={plateWidth} plateLength={plateLength} toleranceFactor={toleranceFactor} qualityCheck={x} qualityCheckChanged={qualityCheckChanged} emptyFieldCodes={emptyFieldCodes}></ToleranceQualityCheck>
                    )
                }
                else if (x.dataTypeId === bool) {
                    return (
                        <YesNoQualityCheck qualityCheck={x} qualityCheckChanged={qualityCheckChanged} ></YesNoQualityCheck>
                    )
                }
            }
            ) : <React.Fragment></React.Fragment>}
            <button className={classes.nextButton} onClick={() => saveQualityChecks()}>{t("SAVE")}</button>
            <AlertDialog dialogOpen={fieldsEmptyDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setFieldsEmptyDialogOpen(false)} action={() => setFieldsEmptyDialogOpen(false)}></AlertDialog>
        </div>
    )
}

const useStyles = makeStyles({
    background: {
        width: "calc(100% - 150px)",
        float: "left",
        padding: "40px",
        boxSizing: "border-box",
        height: "80vh",
        position: "relative",
        top: "90px",
        left: "150px",
    },
    qualityCheckTextField: {
        backgroundColor: "white",
        width: "35%"
    },
    qualityCheckName: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        color: "#020100",
    },
    qualityCheckContainer: {
        width: "100%",
        float: "left",
        height: "80px",
        boxSizing: "border-box"
    },
    toleranceContainer: {
        width: "40%",
        float: "left",
        height: "80px",
        boxSizing: "border-box",
        paddingTop: "30px"
    },
    qualityCheck: {
        width: "100%",
        height: "80px"
    },
    toleranceTitle: {
        textAlign: "center",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "#020100",
        width: "35%",
        float: "left",
        height: "20px",
        position: "relative",
        right: "10px"
    },
    spacer: {
        width: "35%",
        float: "left",
        height: "20px"
    },
    nextButton: {
        width: "120px",
        border: "none",
        cursor: 'pointer',
        outline: "none",
        backgroundColor: FlagstoneTheme.palette.primary.main,
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: "white",
        borderRadius: "5px",
        height: "40px",
        marginBottom: "60px",
        marginTop: "30px"
    },

});